
import React from 'react';

interface PhotorealismIconProps extends React.SVGProps<SVGSVGElement> {}

const PhotorealismIcon: React.FC<PhotorealismIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={1.5} 
    stroke="currentColor" 
    {...props}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 10.5a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5h.008v.008H12V10.5Z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="m10.06 7.06-.18.18-.18-.18a.75.75 0 1 0-1.06 1.06l.18.18-.18.18a.75.75 0 1 0 1.06 1.06l.18-.18.18.18a.75.75 0 1 0 1.06-1.06l-.18-.18.18-.18a.75.75 0 1 0-1.06-1.06l-.18.18Z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="m13.94 13.94-.18.18-.18-.18a.75.75 0 1 0-1.06 1.06l.18.18-.18.18a.75.75 0 1 0 1.06 1.06l.18-.18.18.18a.75.75 0 1 0 1.06-1.06l-.18-.18.18-.18a.75.75 0 1 0-1.06-1.06l-.18.18Z" />
     {/* Represents a camera lens or a sparkle for detail */}
  </svg>
);

export default PhotorealismIcon;
